import React, { FC } from 'react';
import { SystemButtonProps } from '../button.types';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import styles from './brand_secondary_button.module.scss';
import { BaseButton } from '../BaseButton';

export const BrandSecondaryButton: FC<SystemButtonProps> = ({
  dataName,
  ...rest
}) => {
  return (
    <BaseButton {...rest} className={styles.brandSecondary} name={dataName} />
  );
};

BrandSecondaryButton.defaultProps = SystemButtonDefault;
